import launchpadTag from 'url:asset/bento/launchpadtag.png'
import phonePlaceholder from 'url:asset/launchpad/phone_placeholder.png'

export default function LaunchpadTagsSection() {
  return <div className="py-16">
    <div className='flex flex-col md:flex-row overflow-x-hidden overflow-y-clip'>
      <div className="md:w-3/4 px-16 w-full md:order-1 order-2">
        <p className="font-semibold text-2xl md:text-3xl">Launchpad Tags</p>
        <h1 className="font-semibold text-3xl md:text-5xl text-accent">Tap to Launch</h1>

        <p className="font-medium text-2xl md:text-4xl text-[#888888]">
          Launchpad Tags stick to chairs, tables, and more.
          <br />
          <br />
          Open Launchpad with just a tap.
        </p>

        <p className='text-lg mt-8 text-[#888888]'>Launchpad Tags are currently available on a limited basis.</p>
      </div>

      <div className="relative w-full max-w-sm h-[60vh] mx-auto md:mx-8 md:order-2 order-1">
        <img
          src={launchpadTag}
          className="absolute -z-999 inset-0 w-full drop-shadow-[0_4px_8px_rgba(0,0,0,0.2)] -rotate-x-40 rotate-y-20 rotate-z-20"
          draggable={false}
        />

        <img
          src={phonePlaceholder}
          className="absolute w-full z-999 -left-40"
          draggable={false}
        />
      </div>
    </div>
  </div>
}